<template>
    <div class="hero-v2">
        <img class="img" :src="$image(content.imgPath)" :alt="content.title">
        <div class="content">
            <h6 class="font Roboto text-color tertiary subject">
                {{ content.subject }}
            </h6>
            <h2 class="font Roboto title">
                {{ content.title }}
            </h2>
            <span class="font text">{{ content.text }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeroV2',
    props: {
        content: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>

<style lang="scss" scoped>

.hero-v2{
    display: flex;
    flex-direction: column;
    gap: 0;
    .img{
        width: 200px;
        height: 200px;
    }
    .content{
        padding: 24px 0;
        .subject{
            font-size: 20px;
            font-weight: 700;
        }
        .title{
            font-size: 36px;
            font-weight: 800;
        }
        .text{
            font-size: 20px;
            line-height: 28px;
            font-weight: 600;
            letter-spacing: -0.75px;
        }
    }
    @media (min-width: 992px) {
        flex-direction: row;
        gap: 32px;
        .img{
            width: 220px;
            height: 220px;
        }
        .content{
            .subject{
                font-size: 24px;
            }
            .title{
                font-size: 44px;
                font-weight: 700;
            }
            .text{
                font-size: 24px;
                line-height: 32px;
            }
        }
    }
}

</style>
